
import React  from 'react'
import {  map , fixNumber, clamp } from '../../utils/utils'
import { BetType } from './Enums'
import gsap from 'gsap/all'

import '../../scss/live-round.scss'

import liveEllipse from '../../assets/images/live-ellipse.svg'
import arrowDown from '../../assets/images/arrow-down.svg'
import bellowIcon from '../../assets/images/bellow-icon.svg'
import aboveIcon from '../../assets/images/bellow-icon.svg'
import moneyIcon from '../../assets/images/money-icon.svg'

import GameBet, { BetState } from './GameBet'

import {liveRoundMenuCloseHeight} from '../../utils/constants'
import App from '../../App'


export enum LiveMenuState{
    open,
    close
}

interface LiveRoundProps{
    bets : GameBet[];
    liveContest: any;
    openContest: any;
    isMobile:boolean;
    onDetailsPanelHandler : (state:LiveMenuState)=>void;
    btcPrice: number
}

class LiveRound extends React.Component<LiveRoundProps>{   

    interval            :any;
    blinkInterval       :any;

    lastBlink           = true;
    state               = {state:LiveMenuState.close , result:false , showingResult:false}
    lastValue           = 0;
    myCanvas            = React.createRef<HTMLCanvasElement>();    
    mainDiv             = React.createRef<HTMLDivElement>();
    graphicsDiv         = React.createRef<HTMLDivElement>();
    liveDetails         = React.createRef<HTMLDivElement>();
    liveDetailsFooter   = React.createRef<HTMLDivElement>();
    resultDiv           = React.createRef<HTMLDivElement>();
    liveEllipseImage    = React.createRef<HTMLImageElement>();

    lastX = 0;
    

    componentDidMount = ()=>{
        this.interval = setInterval(()=>{
            this.updateCanvas();
        },100)


        this.blinkInterval  = setInterval(()=>{
            this.lastBlink = !this.lastBlink;
            gsap.to(this.liveEllipseImage.current , {duration:0.1,opacity:this.lastBlink?1:0})
        },200)

        this.setLiveRoundState(LiveMenuState.close);
        this.hideResult(0);

    }

    componentWillUnmount = ()=>{
        clearInterval(this.interval);
        clearInterval(this.blinkInterval);
        
    }

    showResult = (result : boolean , time : number = 0.5)=>{
        this.setState({result , showingResult:true})
        gsap.to(this.resultDiv.current , {
            width:this.props.isMobile ? '90%' : '400px',
            duration:time
        })
    }

    hideResult = (time : number = 0.5)=>{
        this.setState({showingResult:false})
        gsap.to(this.resultDiv.current , {
            width:'0%',
            duration:time
        })
    }
    
    updateCanvas = ()=>{

        if(!this.myCanvas || !this.myCanvas.current || this.props.liveContest.instrumentPrices[0].livePrice.blendedPrice === 0)return;
        // if(!this.myCanvas || !this.myCanvas.current) return

        const background = App.getPropertyFromStyle('--live-round-background');
        const primary = App.getPropertyFromStyle('--win-color');
        const secondary = App.getPropertyFromStyle('--lose-color');
        
        const w = this.graphicsDiv.current!.offsetWidth;
        const h = this.graphicsDiv.current!.offsetHeight;

        this.myCanvas.current!.width = w;
        this.myCanvas.current!.height = 80;
        
        const ctx = this.myCanvas.current!.getContext("2d") as CanvasRenderingContext2D;
        ctx.clearRect(0, 0, w, h);

        const min = this.props.liveContest.instrumentPrices[0].livePrice.blendedPrice * 0.999;
        const max = this.props.liveContest.instrumentPrices[0].livePrice.blendedPrice * 1.001;

        // const bgCcolor = this.props.bets[0].state !== BetState.live ? background : background;
        const bgCcolor = background;

        const barH = 3;

        let grd = ctx.createLinearGradient(0, h * 0.5, w , h* 0.5);
        grd.addColorStop(0, bgCcolor);
        grd.addColorStop(0, bgCcolor);
        grd.addColorStop(1, secondary);

        ctx.fillStyle = grd;
        ctx.fillRect(w * 0.1, h * 0.5 - barH * 0.5, w * 0.4,barH);

        grd = ctx.createLinearGradient(0, h * 0.5, w , h* 0.5);
        grd.addColorStop(0.5,primary );
        grd.addColorStop(1, bgCcolor);
        
        ctx.fillStyle = grd;
        ctx.fillRect(w * 0.5,h * 0.5 - barH * 0.5 , w * 0.4 ,barH)

        
        const clampVal = clamp(this.props.btcPrice, min , max)
        const posTo = map(clampVal , min , max , w * 0.2 ,  w * 0.8);

        if(this.lastX === 0)
            this.lastX = posTo;

        let posX = this.lastX;
        posX += (posTo - posX) * 0.1;
        
        const posY = h * 0.5;

        const diamondSize = 10;
        const diamondSizeSmall = diamondSize * 0.7;

        const diamondColor = posX < w / 2 ? secondary : primary;        
        ctx.save();
        ctx.fillStyle = diamondColor;
        ctx.translate(posX, posY);
        ctx.rotate(45 * Math.PI/180);
        ctx.fillRect(-diamondSize * 0.5, -diamondSize * 0.5, diamondSize, diamondSize);
        ctx.fillStyle = background;
        ctx.fillRect(-diamondSizeSmall * 0.5, -diamondSizeSmall * 0.5, diamondSizeSmall, diamondSizeSmall);
        ctx.restore();

        const markerW = 2;
        const markerH = 20;
        ctx.fillStyle = '#F1F1F1';
        ctx.fillRect(w * 0.5 - markerW * 0.5,(h * 0.5) - markerH * 0.5 , markerW ,markerH )


        this.lastX = posX;
    }

    /*updateBackground = ()=>{

        if(!this.graphicsDiv || !this.graphicsDiv.current)return;

        const bgCcolor = '#0F1724';

        gsap.to(this.graphicsDiv.current,{
            duration:0.5,
            background:bgCcolor
        })

        gsap.to(this.liveDetailsFooter.current,{
            duration:0.5,
            background:bgCcolor
        })
        
    }*/

    render(){

        //this.updateBackground();
        const gameBet : GameBet = this.getLiveBet();
        return (
            <div  onClick={()=>{
                if(!this.getLiveBet() || this.state.showingResult)return;
                this.openDetails(this.state.state === LiveMenuState.open ? LiveMenuState.close : LiveMenuState.open);

            }} ref={this.mainDiv} className={this.props.isMobile ? "live-round" : "live-round-desktop"}>   
                <div className="live-round-header">
                    <div className="live-round-header-live">
                        <p>Live round</p>
                        <img ref={this.liveEllipseImage} src={liveEllipse} alt="live ellipse"></img>
                    </div>
                    <p  className="live-round-header-price">Locked price: <span className='live-round-header-price-value'>{this.props.liveContest.instrumentPrices[0].livePrice.blendedPrice? fixNumber(this.props.liveContest.instrumentPrices[0].livePrice.blendedPrice ) : "Loading..." }</span></p>
                    <div className={gameBet ? "live-round-header-your-bet-show" : "live-round-header-your-bet-hide"}>
                        <p>Your Bet: 
                            <span className={(this.getLiveBet() && this.getLiveBet().betType === BetType.closeAbove) ? "live-status-above" : "live-status-bellow" }>
                            {
                                (this.getLiveBet() && this.getLiveBet().betType === BetType.closeAbove) ? " Above" : " Below" 
                            }
                            </span>
                        </p>
                    </div>
                </div>
                <div ref={this.graphicsDiv} className="live-round-graphic">
                    <div ref={this.resultDiv} className="result">
                        <div className="result-content">
                            <div className="result-content-copy">
                                <h2 className="result-content-copy-header">
                                    {this.state.result ? 'Congratulations!' : 'Better luck next time!'} 
                                </h2>
                                <p>{this.state.result ? 'Your selection was correct.' : ''}</p>
                            </div>
                            <img className="result-content-image" src={moneyIcon} alt="money icon"></img>
                        </div>
                        <div className="result-background">
                        </div>
                    </div>
                    {this.props.liveContest.instrumentPrices[0].livePrice.blendedPrice? 
                        <canvas ref={this.myCanvas}></canvas>
                            :
                        <div className='live-round-graphic-loading'>
                            <p className='lds-dual-ring'></p>  
                        </div>      
                    }
                    
                </div>
                <div className="live-round-details" ref={this.liveDetails}>
                    <div className="live-round-details-header">
                        <img src={this.props.bets.length && this.props.bets[0].betType === BetType.closeBellow ? bellowIcon : aboveIcon} alt="icon"></img>
                        <p>{this.props.bets.length && this.props.bets[0].betType === BetType.closeBellow ? 'Close Below' : 'Close above'}</p>
                    </div>
                    {this.getLiveDataPanel(gameBet)}
                </div>
                <div ref={this.liveDetailsFooter} className="live-detail-footer">
                    {this.getDetailsButton()}
                </div>
            </div>
        )
    }

    getLiveDataPanel = (gameBet : GameBet)=>{
        
        if(!gameBet)
            return <div></div>

        return(
            <div className="live-round-details-footer">
                <div className="live-round-details-footer-left">
                    <p>Your Stake</p>
                    <p className="live-round-details-footer-bold">{`${fixNumber(gameBet.stack)}`}</p>
                </div>
                <div className="live-round-details-footer-right">
                    <p>Confirmed Odds</p>
                    <p className="live-round-details-footer-bold">
                        {gameBet.odds}
                    </p>
                </div>
            </div>
        )
    }

    openDetails = (state : LiveMenuState)=>{
        
        const currentState = state;
        this.setLiveRoundState(currentState);
        this.props.onDetailsPanelHandler(currentState);
    }

    setLiveRoundState = (currentState : LiveMenuState)=>{

        this.setState({state:currentState});

        const height = window.innerWidth < 700 ? 230 : 250;
        
        gsap.to(this.mainDiv.current , {
            duration:0.5,
            height:currentState === LiveMenuState.open ? `${height}px` : `${liveRoundMenuCloseHeight}px`
        })
        gsap.to(this.liveDetails.current , {
            duration:0.5,
            height:currentState === LiveMenuState.open ? `${height * 3}px` : '0px'
        })

    }

    getDetailsButton = ()=>{
        if(this.getLiveBet()){
            return(
                <div className="details-button">
                    <img className={this.state.state === LiveMenuState.open ? "arrow-down-open" : "arrow-down-close" } src={arrowDown} alt="arrow down"></img>
                </div>
            )
        }
    }   

    getLiveBet = () : GameBet =>{
        const len = this.props.bets.length;
        for(let i = 0 ; i < len;i++){
            if(this.props.bets[i].id === this.props.liveContest.id)
                return this.props.bets[i];
        }

        return null;
    }
   

   

}

export default LiveRound;
